import { useEffect, useContext } from "react";
import Button from "../../Reusables/Button/Button";
import "../../../assets/css/TimeMachine/timeMachineNoDataModal.css";
import { AppContext } from "../../../Context/Context";
import useModalClose from "../../../hooks/useModalClose";

const MODAL_ID = "no-data-modal-wrapper-id";

const TimeMachineNoDataModal = () => {
  const { setIsNoHeatMapDataModalOpen } = useContext(AppContext);

  useEffect(() => {
    document.body.classList.add("prevent-scroll");
  }, []);

  const modalCloseHandler = () => {
    document.body.classList.remove("prevent-scroll");
    setIsNoHeatMapDataModalOpen(false);
  };

  useModalClose(MODAL_ID, modalCloseHandler);

  return (
    <div id={MODAL_ID} className="no-data-modal-wrapper">
      <div className="no-data-modal-container">
        <div className="no-data-modal-title">
          <h2>Nothing to Display here!</h2>
        </div>
        <div className="no-data-modal-sub-title">
          <h4>
            No Data on the selected Heatmap Time Range
            <br />
            Please select a different Time Range
          </h4>
        </div>
        <div className="no-data-modal-button-div">
          <Button
            placeholder="Close"
            btnClass="no-data-modal-button"
            onClick={() => modalCloseHandler()}
          />
        </div>
      </div>
    </div>
  );
};

export default TimeMachineNoDataModal;
